type WorkTrackingStatusKey =
  | "WAITING"
  | "PAUSED"
  | "WORKING"
  | "DONE"
  | undefined;

export const workTrackingStatus = {
  WAITING: "작업대기",
  PAUSED: "일시정지",
  WORKING: "작업중",
  DONE: "작업완료",
};

export const getWorkTrackingStatus = (status: WorkTrackingStatusKey) => {
  if (!status) return { status: "-", color: "gray.7" };

  let color: string;
  switch (status) {
    case "WAITING":
      color = "gray.7";
      break;
    case "PAUSED":
      color = "orange.7";
      break;
    case "WORKING":
      color = "green.7";
      break;
    case "DONE":
      color = "red.7";
      break;
    default:
      color = "";
      break;
  }

  return {
    status: workTrackingStatus[status],
    color: color,
  };
};
